import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";
import { FragmentProvider } from "core/components/FragmentProvider";
import { ISubscriptionComponentProps } from "./SubscriptionComponent";
import * as subscriptionMeta from "./subscriptionMeta";

const metaInput = FragmentProvider.getInput<ISubscriptionComponentProps>(subscriptionMeta);

@Form({title: "Subscription Component Config"})
export class SubscriptionComponentConfig {

	@Input({type: metaInput, title: "Subscription Meta Fields"})
	public meta?: string[];

	@Input({type: InputType.CHECKBOX, title: "Show Meta Field Labels"})
	public showMetaLabels?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Meta Field Icons"})
	public showMetaIcons?: boolean;

}

export const subscriptionComponentConfigInput = SubFormWidget.registerForm(SubscriptionComponentConfig);



// WEBPACK FOOTER //
// ./src/panels/subscriptions/component/SubscriptionComponentConfig.ts